import { ScaffoldSelection } from "../../interface";

/**
 * Returns whether a row is present in the selectedRows list.
 *
 * @param selection - The current scaffold selection state.
 * @param rowId - The row ID to check.
 * @returns True if the row is selected.
 */
export const isRowInSelection = (selection: ScaffoldSelection, rowId: string): boolean =>
  selection.selectedRows.some((r) => r.firstCellId === rowId);
